/**
 * Bridges the Tiptap bullet-list HTML the admin editor produces and the
 * one-constraint-per-line string the API expects (`buildContentDoc` on the
 * backend splits it on '\n' into `content.constraints[]`).
 */

export function constraintsToHtml(text: string | undefined | null): string {
  const items = (text ?? '')
    .split('\n')
    .map(line => line.trim())
    .filter(Boolean);
  if (items.length === 0) return '';
  return `<ul>${items.map(item => `<li>${item}</li>`).join('')}</ul>`;
}

export function htmlToConstraints(html: string): string {
  if (!html.trim()) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const items = Array.from(doc.querySelectorAll('li'));
  const blocks = items.length > 0 ? items : Array.from(doc.body.children);
  return blocks
    .map(el => el.innerHTML.trim())
    .filter(Boolean)
    .join('\n');
}
